module.exports = __webpack_public_path__ + "static/media/46.1bc5a2c1.png";